import React from 'react';
import Icon from '../../../components/AppIcon';

const BatchSummaryDashboard = ({ summaryStats }) => {
  const statCards = [
    {
      title: 'Total Batches',
      value: summaryStats?.totalBatches,
      icon: 'Layers',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/20'
    },
    {
      title: 'Active Processing',
      value: summaryStats?.activeBatches,
      icon: 'Loader2',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      borderColor: 'border-accent/20',
      animate: true
    },
    {
      title: 'Completed Today',
      value: summaryStats?.completedToday,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20'
    },
    {
      title: 'Failed Batches',
      value: summaryStats?.failedBatches,
      icon: 'AlertCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      borderColor: 'border-error/20'
    },
    {
      title: 'Total Invoices',
      value: summaryStats?.totalInvoices?.toLocaleString(),
      icon: 'FileText',
      color: 'text-foreground',
      bgColor: 'bg-muted',
      borderColor: 'border-border'
    },
    {
      title: 'Avg Processing Time',
      value: summaryStats?.avgProcessingTime,
      icon: 'Clock',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      borderColor: 'border-secondary/20'
    }
  ];

  return (
    <div className="mb-6">
      <div className="flex items-center space-x-3 mb-4">
        <div className="flex items-center justify-center w-10 h-10 bg-gradient-to-br from-primary to-accent rounded-lg">
          <Icon name="BarChart3" size={20} color="white" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-foreground">Batch Processing Overview</h2>
          <p className="text-sm text-muted-foreground">
            Real-time monitoring of all batch operations
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
        {statCards?.map((card, index) => (
          <div
            key={card?.title}
            className={`
              bg-card border rounded-lg p-4 hover:shadow-md transition-all duration-200
              ${card?.borderColor} hover:scale-102
            `}
          >
            <div className="flex items-center justify-between mb-3">
              <div className={`
                flex items-center justify-center w-10 h-10 rounded-lg border
                ${card?.bgColor} ${card?.borderColor}
              `}>
                <Icon 
                  name={card?.icon} 
                  size={18} 
                  className={`${card?.color} ${card?.animate ? 'animate-spin' : ''}`}
                />
              </div>
              
              {/* Trend indicator for some cards */}
              {(card?.title === 'Completed Today' || card?.title === 'Total Invoices') && (
                <div className="flex items-center space-x-1 text-success">
                  <Icon name="TrendingUp" size={14} />
                  <span className="text-xs font-medium">+12%</span>
                </div>
              )}
            </div>

            <div className="space-y-1">
              <div className={`text-2xl font-bold ${card?.color}`}>
                {card?.value}
              </div>
              <div className="text-sm text-muted-foreground">
                {card?.title}
              </div>
            </div>

            {/* Progress indicator for active processing */}
            {card?.title === 'Active Processing' && card?.value > 0 && (
              <div className="mt-3">
                <div className="flex items-center justify-between text-xs text-muted-foreground mb-1">
                  <span>Processing</span>
                  <span>78%</span>
                </div>
                <div className="w-full bg-muted rounded-full h-1.5">
                  <div className="bg-accent h-1.5 rounded-full animate-pulse" style={{ width: '78%' }} />
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      {/* Quick Actions Bar */}
      <div className="mt-6 p-4 bg-muted/50 rounded-lg border border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-accent rounded-full animate-pulse" />
              <span className="text-sm font-medium text-foreground">
                {summaryStats?.activeBatches} batches processing
              </span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-success rounded-full" />
              <span className="text-sm text-muted-foreground">
                Last completion: 2 minutes ago
              </span>
            </div>
          </div>
          
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="RefreshCw" size={14} />
            <span>Auto-refresh: 30s</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BatchSummaryDashboard;

